module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "aeris-cartouche-host"
  }, [(_vm.isvisible) ? _c('span', {
    staticClass: "aeris-cartouche-container"
  }, [(_vm.icon) ? _c('span', [_c('i', {
    class: _vm._getIconStyle
  })]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.edit) ? _c('span', [_c('i', {
    staticClass: "aeris-cartouche-delete fa fa-times",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm._handleClick($event)
      }
    }
  })]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-190dd651","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aeris-cartouche/aeris-cartouche.vue
// module id = 170
// module chunks = 0